package com.nonopn.skywatcher.common.app.home

import com.nonopn.skywatcher.common.api.ApiProvider
import com.nonopn.skywatcher.common.app.api.impl.ApiInterface
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetectionWithMetadata
import eu.codlab.navigation.RouteParameterTo

private const val Millis = 1000.0

data class AppModelState(
    var initialized: Boolean = false,
    var loading: Boolean = false,
    val isSystemDarkMode: Boolean,
    val thunderDetections: List<ThunderDetectionWithMetadata> = emptyList(),
    val selectedThunderDetection: ThunderDetectionWithMetadata? = null,
    val apiProvider: ApiProvider<ApiInterface>? = null,
    val currentApi: ApiInterface? = null,
    val defaultRoute: RouteParameterTo? = null,
    val notificationPermissionState: Boolean? = null,
    val notificationPermissionRequested: Boolean = false
)
